export function createTokenStore() {
    let token = null;
    return {
        get: () => token,
        set: (t) => {
            token = t;
        },
    };
}
//# sourceMappingURL=tokenStore.js.map